export function buildTaxCategoryId(
  applyToCategory,
  selectedCategories,
  categoryOptions
) {
  if (!applyToCategory) return "";

  const selected = Array.isArray(selectedCategories) ? selectedCategories : [];
  const options = Array.isArray(categoryOptions) ? categoryOptions : [];

  if (
    options.length > 1 &&
    selected.length > 0 &&
    selected.length === options.length
  ) {
    return "all";
  }

  return selected
    .map((item) => item?.id)
    .filter((id) => id !== undefined && id !== null && `${id}`.trim() !== "")
    .join(",");
}

export function getTaxCategoryDisplayLabels(selectedCategories, categoryOptions) {
  const selected = Array.isArray(selectedCategories) ? selectedCategories : [];
  const options = Array.isArray(categoryOptions) ? categoryOptions : [];

  if (options.length > 1 && selected.length > 0 && selected.length === options.length) {
    return ["All"];
  }

  return selected.map((item) => item?.title).filter(Boolean);
}
